module.exports = __webpack_public_path__ + "static/11-1-86c5a3190e4ab4ad09f70f9bf6b51522.jpg";